import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Comentario } from '@app/core/entities/comentario/comentario';
import { ComentarioInterface } from '@app/core/interfaces/comentario-interface';
import { IRequestPatchTarea, IRequestPostTareaCancelar, IRequestPostTareaFinalizar, ITarea, ITareaConfiguraciones, ITareaLugares } from '@app/core/interfaces/ITarea';
import { IRespApi } from '@app/neo/neoShared/helpers/interfaces/IResp-api';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { EmpleadosService } from '../empleados/empleados.service';

export enum LocalizacionesEnum  {
  Duacode = '2',
  Exterior = '3',
  Online = '1'
}

export enum idTareaLugarEnum  {
  Online = '4',
  Exterior = '6'
}

export enum TareasConfiguracionesEnum  {
  ReunionRequerimientosTecnicos = '1',
  ValidacionComericial= '2',
  EsperandoRespuestaCliente = '3',
  RedefinicionRequisitos = '4',
  EstimacionPropuesta = '5',
  PropuestaEnNegociacion = '6',
}

// TODO funcionlidad ngx chips
export interface IOpcionesChips {
  id: string,
  nombre: string,
  disabled: boolean
}

@Injectable({
  providedIn: 'root'
})
export class TareasService {

  urlTareas          = environment.api_base_url + '/tareas';
  urlTareaLugares    = environment.api_base_url + '/tareaLugares';
  urlTareaLugaresItem= environment.api_base_url + '/tareaLugarItem';
  urlTareasConfiguraciones    = environment.api_base_url + '/tareaConfiguraciones';

  // llevar a servicio propio de comentarios
  urlTextos   = environment.api_base_url + '/textos';

  public error422Api$: Subject<RespApi> = new Subject<RespApi>();
  
  public tarea$: BehaviorSubject<ITarea> = new BehaviorSubject<ITarea>(null);
  public tareas$: BehaviorSubject<ITarea[]> = new BehaviorSubject<ITarea[]>([]);
  public totalTareas$: BehaviorSubject<number> = new BehaviorSubject<number>(null);


  public localizaciones$: BehaviorSubject<ITareaLugares[]> = new BehaviorSubject<ITareaLugares[]>([]);
  public localizacion$: BehaviorSubject<ITareaLugares> = new BehaviorSubject<ITareaLugares>(null);
  public lugares$: BehaviorSubject<ITareaLugares[]> = new BehaviorSubject<ITareaLugares[]>([]);
  public lugar$: BehaviorSubject<ITareaLugares> = new BehaviorSubject<ITareaLugares>(null);
  



  public tareasLugares$: BehaviorSubject<ITareaLugares[]> = new BehaviorSubject<ITareaLugares[]>([]);
  public tareaLugares$: BehaviorSubject<ITareaLugares> = new BehaviorSubject<ITareaLugares>(null);

  public tareasConfiguraciones$: BehaviorSubject<ITareaConfiguraciones[]> = new BehaviorSubject<ITareaConfiguraciones[]>(null);
  public tareaConfiguraciones$: BehaviorSubject<ITareaConfiguraciones> = new BehaviorSubject<ITareaConfiguraciones>(null);
  public totalTareasConfiguraciones$: BehaviorSubject<number> = new BehaviorSubject<number>(null);


  // particpantes reunion
  public participantesPreestablecidos$ : BehaviorSubject<IOpcionesChips[]> = new BehaviorSubject<IOpcionesChips[]>(null);
  public participantesSeleccionables$ : BehaviorSubject<IOpcionesChips[]> = new BehaviorSubject<IOpcionesChips[]>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private empleadosService: EmpleadosService
  ) { }

  set tarea(tarea: ITarea) {
    this.tarea$.next(tarea);
  }

  set tareas(tareas: ITarea[]) {
    this.tareas$.next(tareas);
  }

  set tareasLugares(tareasLugares: ITareaLugares[]) {
    // console.log('ESTABLECEMOS TAREAS LUGARES ', tareasLugares);
    this.tareasLugares$.next(tareasLugares);
  }

  set tareaLugar(tareaLugar: ITareaLugares) {
    // console.log('Seleccion de tarea ', tareaLugar);
    this.tareaLugares$.next(tareaLugar);
  }

  // nuevo 
  set localizaciones(localizaciones: ITareaLugares[]) {
    // console.log('Localizaciones ', localizaciones);
    this.localizaciones$.next(localizaciones);
  }

  set localizacion(localizacion: ITareaLugares) {
    // console.log('Seleccion de tarea ', localizacion);
    this.localizacion$.next(localizacion);
  }

  set lugares(lugares: ITareaLugares[]) {
    // console.log('lugares ', lugares);
    this.lugares$.next(lugares);
  }

  set lugar(lugar: ITareaLugares) {
    // console.log('Seleccion de tarea ', lugar);
    this.lugar$.next(lugar);
  }

  set tareaConfiguraciones(tarea: ITareaConfiguraciones) {
    this.tareaConfiguraciones$.next(tarea);
  }

  set tareasConfiguraciones(tareas: ITareaConfiguraciones[]) {
    this.tareasConfiguraciones$.next(tareas);
  }

  set participantesPreestablecidos(opciones: IOpcionesChips[]) {
    this.participantesPreestablecidos$.next(opciones);
  }

  set participantesSeleccionables(opciones: IOpcionesChips[]) {
    this.participantesSeleccionables$.next(opciones);
  }

  // contenido options de los select entidades
  // mapearListadosEntidadesRelacionadas(paginatorType?: TipoPaginadorEnum, paginator?: Paginator): Observable<any> {
  //   const responseEmpleados                  = this.empleadosService.getAll(paginatorType, paginator, {orden: 'nombre', tipoOrden: 'asc'});
  //   const responseTareaLugares              = this.getTareaLugares();
  //   const responseTipoTareaConfiguracion     = this.getTareasConfiguraciones();
  //   return forkJoin([
  //     responseEmpleados,
  //     responseTareaLugares,
  //     responseTipoTareaConfiguracion
  //   ]);
  // }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ITarea[]> {
    let request = (paginatorType === TipoPaginadorEnum.offline) 
    ? this.urlTareas 
    : `${this.urlTareas}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, {}).pipe(
        tap( (data: RespApi )=> {this.totalTareas$.next( data.total );}),
        map( (data: RespApi) => data['data']) ); 
  }

  get(id): Observable<ITarea>{
    return this.http.get(`${this.urlTareas}/${id}`).pipe(
      map(  (data: RespApi) =>  data['data'])
    );
  }


  getTareasConfiguraciones(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ITareaConfiguraciones[]> {
    let request = (paginatorType === TipoPaginadorEnum.offline) 
    ? this.urlTareasConfiguraciones 
    : `${this.urlTareasConfiguraciones}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, {}).pipe(
        map( (data: RespApi) => data['data']) ); 
  }

  getTareaConfiguraciones(id): Observable<ITareaConfiguraciones>{
    return this.http.get(`${this.urlTareasConfiguraciones}/${id}`).pipe(
      map(  (data: RespApi) =>  data['data']),
      tap( data => this.tareaConfiguraciones = data)
    );
  }

  getEnlaceGoogleMeet(id): Observable<string>{
    return this.http.get(`${this.urlTareasConfiguraciones}/${id}`).pipe(
      map(  (data: RespApi) =>  data['data'])
    );
  }

  update(id: string, request: IRequestPatchTarea) {
    return this.http.patch( `${this.urlTareas}/${id}`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPatchTarea');
      })
    );
  }

  cancelar(id: string, request: IRequestPostTareaCancelar) {
    return this.http.post( `${this.urlTareas}/${id}/cancelar`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPostTareaCancelar');
      })
    );
  }

  finalizar(id: string, request: IRequestPostTareaFinalizar) {
    return this.http.post( `${this.urlTareas}/${id}/finalizar`, request ).pipe(
      tap((data: RespApi) => console.log('Tara finalizada ', data)),
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        // console.log('Tara finalizada error', err)
        return this.handleError( err,  'IRequestPostTareaFinalizar');
      })
    );
  }

  delete(id: string): Observable<any>{
    return this.http.delete(`${this.urlTareas}/${id}`).pipe(
      map((data: any[]) => !data['error']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestDeleteTarea');
      })
    );    
  }

  /********************************/
  /* COMENTARIOS                  */
  /********************************/
  getComentarios(tarea): Observable<Comentario[]> {
    let filtros = { orden: 'id', tipoOrden: 'asc' };
    return this.http.get(`${this.urlTareas}/${tarea.id}/comentarios?${this.auxiliar.extraerFiltros(filtros)}`).pipe(
      // tap( data => console.log('info comentarios ', data)),
      map((data: RespApi) => this.mapearComentario(data.data, tarea.id))
    );
 
  }

  mapearComentario(comentarios: Comentario[], idObjeto: string): Comentario[] {
    comentarios.map(object => Object.assign(object, {
      idObjeto      
    }));
    return comentarios;
  }

  createComentario(comentario: ComentarioInterface): Observable<any> {

    if( comentario ) {
      const objComentario = Object.assign({texto: comentario.contenido});
      return this.http.post(`${this.urlTareas}/${comentario.idObjeto}/comentarios`, objComentario).pipe(
        map( (data:RespApi) => data),
        catchError( (err: RespApi) => {       
          return this.handleError( err);
        })
      );     
    } else {
      return throwError(new Error('Error'));
    }
    
  }

  updateComentario(comentario: ComentarioInterface): Observable<any> {
    const objComentario = Object.assign({texto: comentario.contenido});
    return this.http.patch( `${this.urlTextos}/${comentario.id}`, objComentario ).pipe(
      map((data: ComentarioInterface[]) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err);
      })
    );
  }

  deleteComentario(comentario: ComentarioInterface): Observable<any> {
    if (comentario) {
      return this.http.delete(`${this.urlTextos}/${comentario.id}`).pipe(
        catchError( (err: RespApi) => {       
          return this.handleError( err);
        })
      );
    } else {
      return throwError(new Error('Error'));
    }
  }

  
  /************************************ 
   *   TareaLugares    asociadas        *
  *************************************/
  // Listado de lugares disponibles para tarea borrar
  getTareaLugares(): Observable<ITareaLugares[]> {
    return this.http.get(`${this.urlTareaLugares}`).pipe(
      map((data: RespApi) =>  {
        if ( data.total > 0 ) {
          return data['data'];
        } else {
          return [];
        }
      }),
      tap( (data: ITareaLugares[] )=> this.tareasLugares = data)
    );
  }  

  // lugar de la tarea borrar
  getTareaLugar(id: string ): Observable<ITareaLugares> {
    return this.http.get(`${this.urlTareaLugares}/${id}`).pipe(
      map((data: RespApi) =>  data['data'])
    );
  }  


  getLocalizaciones(): Observable<ITareaLugares[]> {
    let request = `${this.urlTareaLugares}`;
    return this.http.get(request, {}).pipe(
      tap((data: IRespApi) => this.localizaciones$.next(data.data)),
      map((data: IRespApi) => data.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetLocalizaciones');
      })
    );



    return this.http.get(`${this.urlTareaLugares}`).pipe(
      map((data: RespApi) =>  {
        if ( data.total > 0 ) {
          return data['data'];
        } else {
          return [];
        }
      }),
      // tap( (data: ITareaLugares[] )=> this.localizaciones = data)
    );
  }  

  getLugares(idLocalizacion): Observable<ITareaLugares[]> {
    return this.http.get(`${this.urlTareaLugares}/${idLocalizacion}`).pipe(
      map((data: RespApi) =>  {
        if ( data.total > 0 ) {
          return data['data'];
        } else {
          return [];
        }
      }),
      tap( (data: ITareaLugares[] )=> this.lugares = data)
    );
  }  

  getTareaLugarItem(id: string ): Observable<ITareaLugares> {
    return this.http.get(`${this.urlTareaLugaresItem}/${id}`).pipe(
      map((data: RespApi) =>  data['data'])
    );
  }  
  

 /************************************ 
   * Funciones apoyo                  *
  *************************************/
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {
      localizaciones: this.getLocalizaciones().pipe(
        catchError(err => of(null))
      )
    };
    return forkJoin(peticion);
  }
  
   /********************************/
  /* MANEJADOR ERRORES            */
  /********************************/
private handleError(err: RespApi, idRequest = '') {
  // control error server con un html ok
  if (err == 'OK') {
    let mensaje = environment.errorServidorSinCodigo;
    return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
  }
  if (err == 'Unknown Error') {
    let mensaje = environment.errorServidorUnknown;
    return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
  }
  // dialog específico
  err.request = idRequest;
  if ( err.codigoError === 422) {
    this.error422Api$.next(err);
  } 

  // pantalla común
  let mensaje = err?.mensaje;
  if ( err.codigoError === 403) {
    mensaje = `${ err.mensaje }: `;
    err.data.forEach(element => {
      mensaje += element.mensaje;
    });
  }
  if (err.codigoError === 404) {
    let avisos = '';
    if ( err.data ) {
      err.data.forEach(element => {
        if ( element.id === 999 ) {
          avisos = ' ' + element.mensaje + ' ';
        }
      });
    }
    mensaje = err?.mensaje +  avisos;
  }

  if (err.codigoError === 500) {
    let avisos = '';
    if ( err.data ) {
      err.data.forEach(element => {
        if ( element.id === 999 ) {
          avisos = ' ' + element.mensaje + ' ';
        }
      });
    }
    mensaje = err?.mensaje +  avisos;
  }
  return throwError({'error' : true, 'data': err.data, mensaje });
}
}
